import styled from 'styled-components'
import media from '../../../utils/style'
import IconRefresh from '../../../vectors/IconRefresh'

const IconClearFilters = styled(IconRefresh)`
  width: 18px;
  transform: scale(0.75) translateY(40%) translateX(40%);
  ${media.LargeScreenUp`
    transform: scale(1) translateY(30%) translateX(40%);
  `};
`
IconClearFilters.displayName = 'IconClearFilters'

export default IconClearFilters
